import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms';
import{LoopBackAuth, listadosService, matriculaService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import { isNull } from 'util';
/**
 *Seccion ingreso y modificacion datos de curso del estudiante
 *
 * @export
 * @class DatosCursoComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'datos-curso',
  template: `
    <form name="form-inscripciones" [formGroup]="cursoAlumno">
      <div class="row">
        <label class="col-sm-2 col-form-label text-right pl-0"> 
        Curso/Grado: <span class="text-danger">*</span> </label>
        <div class="col-sm-3 pr-0">
          <div 
            class="input-group input-group-sm mb-0"
            [ngClass]="{'showError': !cursoAlumno.get('nivel').valid && (cursoAlumno.get('nivel').touched && cursoAlumno.get('nivel').value == null) }">
              <select 
              name="curso" 
              [style.border-radius]="'0px'"
              class="form-control"
              formControlName="nivel"
              (change)="onChangeEspecialidad()">
              <option value="null">SELECCIONE CURSO/GRADO</option>
              <option *ngFor="let item of niveles" [value]="item.id">{{item.descripcion | uppercase}}</option>
            </select>
          </div>
        </div>
        <label class="col-sm-1 col-form-label text-right pl-0 pr-0"> 
          Nivel: <span class="text-danger">*</span> </label>
        <div class="col-sm-3 pr-0">
          <div 
            class="input-group input-group-sm mb-0"
            [ngClass]="{'showError': !cursoAlumno.get('especialidad').valid && (cursoAlumno.get('especialidad').touched && cursoAlumno.get('especialidad').value == null) }">
            <select 
              name="nivel" 
              class="form-control"
              [style.border-radius]="'0px'"
              formControlName="especialidad"
              (change)="onChangeParalelos()">
              <option value="null">SELECCIONE NIVEL</option>
              <option *ngFor="let item of especializaciones" [value]="item.id">
                {{item.descripcion | uppercase}}
              </option>
            </select>
          </div>
        </div>
        <label class="col-sm-1 col-form-label text-right pl-0 pr-0"> 
            Paralelo: <span class="text-danger">*</span> </label>
        <div class="col-sm-2">
          <div 
          class="input-group input-group-sm mb-0"
          [ngClass]="{'showError': !cursoAlumno.get('paralelo').valid && (cursoAlumno.get('paralelo').touched && cursoAlumno.get('paralelo').value == null) }">
            <select 
              name="paralelo" 
              class="form-control"
              [style.border-radius]="'0px'"
              (change)="asignarCursoCompleto()"
              formControlName="paralelo">
              <option value="null">SELECCIONE PARALELO</option>
              <option *ngFor="let item of paralelos" [value]="item.id">{{item.descripcion | uppercase}}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  `,
  providers:[LoopBackAuth, listadosService, matriculaService, MessageService]
})
export class DatosCursoComponent implements OnInit {
  @Input() cursoAlumno: FormGroup
  @Input() spinner: any
 
  /** Variable locales*/
  public niveles: any =[]
  public especializaciones: any =[]
  public paralelos: any =[]
  public cusosCompletos: any =[]

  constructor(private matriculaService:matriculaService) { }

  ngOnInit() {
    this.matriculaService.listasCursos('nivel',0).subscribe(
        result=>{
            this.niveles = result
            /** Valido != null para no llamar a las funciones de llenar los otros combos */
            if(!isNull(this.cursoAlumno.get('nivel').value)) this.onChangeEspecialidad()
        }
    )

  }

  /**
   * Cuando cambie el combo del nivel solicito la informacion de especialidades y paralelos
   *
   * @memberof DatosCursoComponent
   */
  onChangeEspecialidad(){
    this.spinner.isSpinnerVisible = true
    this.matriculaService.searchCursoPorNivel(this.cursoAlumno.get('nivel').value, null,null).subscribe(
      lista =>{
          if(!isNull(lista)){
            this.cusosCompletos = lista
            let especialidades = []
            for (let item  of lista){
              let count =0
              for(let especialidad of especialidades){
                if(item.aca_curso_especialidad_id == especialidad.id) count++
              }
              if(count == 0) especialidades.push({id: item.aca_curso_especialidad_id, descripcion: item.aca_curso_especialidad_descripcion})
            }
            this.especializaciones = especialidades
            this.onChangeParalelos()
            
          }
          this.spinner.isSpinnerVisible = false
      }
    )
  }

  /**
   * Cuando se modifique el combo de especializacion busco los paralelos de la espcializacion escojida
   *
   * @memberof DatosCursoComponent
   */
  onChangeParalelos(){
    let paralelos = []
    for (let item  of this.cusosCompletos){
       if(item.aca_curso_especialidad_id == this.cursoAlumno.get('especialidad').value){
         paralelos.push({id:item.aca_curso_paralelo_id, descripcion: item.aca_curso_paralelo_descripcion})
       }
    }
    this.paralelos = paralelos
  }

  public asignarCursoCompleto(){
    let cursoCompleto = this.cusosCompletos.filter(x=>    x.aca_curso_nivel_id == this.cursoAlumno.get('nivel').value 
                                                  && x.aca_curso_especialidad_id == this.cursoAlumno.get('especialidad').value
                                                  && x.aca_curso_paralelo_id == this.cursoAlumno.get('paralelo').value)
    if(cursoCompleto.length > 0){
      this.cursoAlumno.get('cursoCompleto').setValue(cursoCompleto[0].aca_curso_completo_id)
    }else{
      this.cursoAlumno.get('cursoCompleto').setValue(null)
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-curso.component.ts